module.exports = __webpack_public_path__ + "static/soap-1438a0c5b094741ea02ffaeaf8f8d6fa.pdf";